import { Button } from "@/components/ui/button";
import { CheckCircle, X, MapPin } from "lucide-react";

interface AddressConfirmationProps {
  onConfirm: () => void;
  onReject: () => void;
  isConfirmed: boolean;
  disabled?: boolean;
}

export const AddressConfirmation = ({
  onConfirm,
  onReject,
  isConfirmed,
  disabled = false
}: AddressConfirmationProps) => {
  if (isConfirmed) {
    return (
      <div className="flex items-center gap-2 p-3 bg-green-50 border border-green-200 rounded-md">
        <CheckCircle className="h-5 w-5 text-green-600" />
        <span className="text-sm font-medium text-green-800">
          Map location confirmed!
        </span>
        <Button
          variant="ghost"
          size="sm"
          onClick={onReject}
          disabled={disabled}
          className="ml-auto text-green-700 hover:text-green-800 hover:bg-green-100"
        >
          Share a more accurate pin
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-3 p-3 border border-green-200 bg-green-50 rounded-md">
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onConfirm}
          disabled={disabled}
          className="flex-1 border-green-600 text-green-700 hover:bg-green-50"
        >
          <CheckCircle className="h-4 w-4 mr-2" />
          Confirm Location
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={onReject}
          disabled={disabled}
          className="flex-1 border-amber-600 text-amber-700 hover:bg-amber-50"
        >
          <MapPin className="h-4 w-4 mr-2" />
          Share a more accurate pin
        </Button>
      </div>
    </div>
  );
};